import { environmentHttpClient } from "client/Api/httpClient";

export const enum ToDoListIdentifierKind {
	Default = 1,
	Specific = 3,
	Planner = 4,
	WellKnown = 5
}

export enum WellKnownTodoListKind {
	FlaggedEmails = 1
}

export type DefaultToDoListIdentifier = {
	kind: ToDoListIdentifierKind.Default;
};

export type PlannerToDoListIdentifier = {
	kind: ToDoListIdentifierKind.Planner;
};

export type SpecificToDoListIdentifier = {
	kind: ToDoListIdentifierKind.Specific;
	id: string;
};

export type WellKnownToDoListIdentifier = {
	kind: ToDoListIdentifierKind.WellKnown;
	id: string;
	wellKnownListKind: WellKnownTodoListKind;
};

export type ToDoListIdentifier =
	| DefaultToDoListIdentifier
	| PlannerToDoListIdentifier
	| SpecificToDoListIdentifier
	| WellKnownToDoListIdentifier;

export type ToDoListModel = {
	identifier: ToDoListIdentifier;
	name: string;
};

export function listToDoLists(signal?: AbortSignal): Promise<ToDoListModel[]> {
	return environmentHttpClient.get<ToDoListModel[]>(
		"/Workspace/LiveInformation/ToDoLists",
		undefined,
		{ signal }
	);
}
